// Navigation service to handle programmatic navigation
// This allows non-React code (like services) to use React Router navigation

type NavigateFunction = (to: string, options?: { replace?: boolean }) => void;

class NavigationService {
  private navigateFunction: NavigateFunction | null = null;

  // Set the navigate function from React Router
  setNavigate(navigate: NavigateFunction): void {
    this.navigateFunction = navigate;
  }

  // Navigate to a route
  navigate(to: string, options?: { replace?: boolean }): void {
    if (this.navigateFunction) {
      this.navigateFunction(to, options);
    } else {
      // Fallback to window.location if navigate function is not set
      console.warn('Navigate function not set, falling back to window.location');
      if (options?.replace) {
        window.location.replace(to);
      } else {
        window.location.href = to;
      }
    }
  }

  // Check if navigation service is properly initialized
  isInitialized(): boolean {
    return this.navigateFunction !== null;
  }
}

// Export a singleton instance
export const navigationService = new NavigationService();